import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import React from 'react';
import { Candidate } from '../uploadPreview.type';
import { ColumnDef } from '@tanstack/react-table';

export const candidateTablecolumns: ColumnDef<Candidate>[] = [
  {
    id: 'username',
    header: 'Student Name',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { username } = original;
      return username ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'registerNumber',
    header: 'Register Number',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { registerNumber } = original;
      return registerNumber ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'gender',
    header: 'Gender',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { gender } = original;
      return gender ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'email',
    header: 'Email Address',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { email } = original;
      return email ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 200 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'contactNumber',
    header: 'Contact Number',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { contactNumber } = original;
      return contactNumber ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'dateOfBirth',
    header: 'Date Of Birth',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { dateOfBirth } = original;
      return dateOfBirth ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'course',
    header: 'Course',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { course } = original;
      return course ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'department',
    header: 'Department',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { department } = original;
      return department ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'yearOfStudy',
    header: 'Year Of Study',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { yearOfStudy } = original;
      return yearOfStudy ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'academicAdvisor',
    header: 'Academic Advisor',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { academicAdvisor } = original;
      return academicAdvisor ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'enrollmentDate',
    header: 'Enrollment Date',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { enrollmentDate } = original;
      return enrollmentDate ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'expectedGraduationDate',
    header: 'Expected Graduation Date',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { expectedGraduationDate } = original;
      return expectedGraduationDate ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 250 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'street',
    header: 'Street',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { street } = original;
      return street ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'city',
    header: 'City',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { city } = original;
      return city ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'state',
    header: 'State',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { state } = original;
      return state ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'postalCode',
    header: 'Postal Code',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { postalCode } = original;
      return postalCode ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  },
  {
    id: 'country',
    header: 'Country',
    accessorKey: '',
    cell: ({ row: { original } }) => {
      const { country } = original;
      return country ?? '-';
    },
    meta: {
      headerProps: { style: { minWidth: 150 } },
      cellProps: { className: 'py-0' }
    },
    enableSorting: false
  }
];

function PreviewTable() {
  return (
    <div>
      <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />
      <AdvanceTableFooter pagination />
    </div>
  );
}

export default PreviewTable;
